import COUNTRY_LIST from "./countryList.json";

const countryObject = {};
const countryOptions = [];

COUNTRY_LIST.forEach((country) => {
  countryObject[country.code] = country;
  countryOptions.push({
    label: country.name,
    value: country.name,
    key: `${country.name}-${country.code}`,
    code: country.code,
    dial_code: country.dial_code,
  });
});

export const isValidCountry = (countryCode) =>
  countryObject[countryCode] ? true : false;

export const getCountry = (countryCode) => {
  return countryObject[countryCode];
};

export const COUNTRY_LIST_ARR = COUNTRY_LIST;
export const COUNTRY_LIST_OBJ = countryObject;
export const COUNTRY_LIST_DROPDOWN_OPTIONS = countryOptions;
